export const DEFAULT_AVATAR =
  "https://firebasestorage.googleapis.com/v0/b/body-36982.appspot.com/o/images%2Fblank%2Fblank_profile.jpeg?alt=media&token=07f1bcd5-89e5-48f5-9e05-dc8b9faa0211";
export const DEFAULT_POSTER =
  "https://firebasestorage.googleapis.com/v0/b/body-36982.appspot.com/o/images%2Fblank%2Fdefault_poster.jpg?alt=media&token=9501d1f2-3e92-45f3-9d54-8d8746ba288d";
